import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';
import { landingPageFormInputs } from './LandingPageForm.config';

export {
  journeyInput,
  showDurationPickerInput,
  landingPageFormInputs,
  getFilteredFormInputs,
} from './LandingPageForm.config';

const LandingPageForm = dynamic(() => import('./LandingPageForm').then((m) => ({ default: m.LandingPageForm })));

const LandingPageFormConfig = {
  name: 'Landingpage Form',
  inputs: landingPageFormInputs,
};

Builder.registerComponent(LandingPageForm, LandingPageFormConfig);
